import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useAuth} from '../../../../auth'
import {useListView} from '../../../../../../_metronic/common/table/core/ListViewProvider'
import {ListLoading} from '../../../../../../_metronic/common/table/loading/ListLoading'
import {getJobById} from '../core/_requests'
import {JobEditModalForm} from './JobEditModalForm'

const JobEditModalFormWrapper = () => {
  const {currentUser} = useAuth()

  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: job,
    error,
  } = useQuery(
    `${QUERIES.JOBS_LIST}-job-${itemIdForUpdate}`,
    () => {
      return getJobById(itemIdForUpdate, currentUser)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <JobEditModalForm isJobLoading={isLoading} job={{id: undefined}} isEdit={false} />
  }

  if (!isLoading && !error && job) {
    return <JobEditModalForm isJobLoading={isLoading} job={job} isEdit={true} />
  }

  if (isLoading) {
    return <ListLoading />
  }

  return null
}

export {JobEditModalFormWrapper}
